/**
 * Based on Vehicle.js in the dashboard folder
 * Renders the Live Image and date from liveMedia.js and eventmedia.js (dashboard folder)
 * Rendered in SnapshotItem.js
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from '../../../localization';

import Protected from '../../common/protected';
import LiveMedia from './LiveMedia'; /* index.js for redux is not available yet */
import EventMedia from 'APP_ROOT/components/pages/dashboard/EventMedia';
import { EVENT_MEDIA_REQUEST_TYPE } from 'APP_ROOT/components/pages/dashboard/EventMedia/eventMediaConstants';
import RavenUtil from '../../common/ravenUtil';

export default class ImageDetails extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    static getDerivedStateFromProps(props, state) {

        if (!props.selectedRaven) { // RAV-3903
            return;
        }

        var liveMediaRoadCameraImage;
        var liveMediaRoadCameraDate;
        var liveMediaCabinCameraImage;
        var liveMediaCabinCameraDate;

        if (props.selectedRaven.liveMedia) {
            if (props.selectedRaven.liveMedia.length > 0) {
                if (props.selectedRaven.liveMedia[0] && props.selectedRaven.liveMedia[0].base64Image) { // RAV-3903 (added truthy check for liveMedia's element at index 0)
                    liveMediaRoadCameraImage = props.selectedRaven.liveMedia[0].base64Image;
                    liveMediaRoadCameraDate = props.selectedRaven.liveMedia[0].timestamp;
                }
                if (props.selectedRaven.liveMedia.length > 1) {
                    if (props.selectedRaven.liveMedia[1] && props.selectedRaven.liveMedia[1].base64Image) { // RAV-3903 (added truthy check for liveMedia's element at index 1)
                        liveMediaCabinCameraImage = props.selectedRaven.liveMedia[1].base64Image;
                        liveMediaCabinCameraDate = props.selectedRaven.liveMedia[1].timestamp;
                    }
                }
            }
        } else if (props.selectedRaven.vehicleState) { // if no live mqtt data, try to fall back on vehicle state
            if (props.selectedRaven.vehicleState.currentPreviewUrls) {
                if (props.selectedRaven.vehicleState.currentPreviewUrls.length > 0) {
                    if (props.selectedRaven.vehicleState.currentPreviewUrls[0]) {
                        liveMediaRoadCameraImage = props.selectedRaven.vehicleState.currentPreviewUrls[0].finalUrl;
                        liveMediaRoadCameraDate = RavenUtil.convertTs(props.selectedRaven.vehicleState.currentPreviewUrls[0].ts);
                    }
                    if (props.selectedRaven.vehicleState.currentPreviewUrls.length > 1) {
                        if (props.selectedRaven.vehicleState.currentPreviewUrls[1]) {
                            liveMediaCabinCameraImage = props.selectedRaven.vehicleState.currentPreviewUrls[1].finalUrl;
                            liveMediaCabinCameraDate = RavenUtil.convertTs(props.selectedRaven.vehicleState.currentPreviewUrls[1].ts);
                        }
                    }
                }
            }
        }

        return {
            liveMediaRoadCameraImage,
            liveMediaRoadCameraDate,
            liveMediaCabinCameraImage,
            liveMediaCabinCameraDate
        }
    }

    onLiveStream = (cameraType, streamStartDate = null) => {
        this.props.onLiveStream({
            ravenUuid: this.liveStreamRavenUuid(),
            vehicleName: this.props.selectedRaven.vehicle.name,
            defaultCamera: cameraType,
            startDate: streamStartDate
        });
    }

    liveStreamRavenUuid = () => {
        const isShowcase = this.props.features.showcase_raven_selector;
        if (isShowcase && this.props.showcaseTargetRavenUuid) {
            return this.props.showcaseTargetRavenUuid;
        }
        return this.props.selectedRaven.ravenUuid
    }

    render() {

        // console.log("VEHICLE DASHBOARD DETAILS PANEL", this.props, this.state);

        if (!this.props.selectedRaven) return null;

        if (this.props.selectedRaven.noServicePlan) {

            var linkurl = "/" + getCurrentLocale() + "/account/ravens?edit=" + this.props.selectedRaven.ravenUuid;

            return (
                <div>
                    <div className="row">
                        <div className="col-12 no-plan-message">
                            <h3>{strings.formatString(strings.no_plan_label)}</h3>
                            <Protected resource="ravens.service_plans" action="write" resourceId={this.props.selectedRaven.ravenUuid} >
                                <p>{strings.formatString(strings.no_plan_db_message, <span><br /><NavLink to={linkurl}>{strings.formatString(strings.click_here)}</NavLink></span>)}</p>
                                <Protected.Fallback>
                                    <p>{strings.no_plan_db_message_guest}</p>
                                </Protected.Fallback>
                            </Protected>
                        </div>
                    </div>
                </div>
            )
        }

        if (!this.props.selectedRaven.dashboard) return null;

        // Some code to safely adapt selectedRaven liveMedia|vehicleState props to liveMedia component props
        var liveMediaRoadCamera = {
            image: this.state.liveMediaRoadCameraImage,
            date: new Date(this.state.liveMediaRoadCameraDate)
        };
        var liveMediaCabinCamera = {
            image: this.state.liveMediaCabinCameraImage,
            date: new Date(this.state.liveMediaCabinCameraDate)
        }

        let mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.NONE;
        if (this.props.features.media_request && this.props.selectedRaven.canRequestMedia && this.props.selectedRaven.apiProfile) {
            if (this.props.selectedRaven.apiProfile.userMediaRequest) {
                mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST;
            } else if (this.props.selectedRaven.apiProfile.videoPreviewRequest) {
                mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.VIDEO_PREVIEW_REQUEST;
            }
        }

        let pathname = window.location.pathname;

        return (
            <div>

                {this.props.features.media_view && this.props.selectedRaven.canViewMedia ?

                    <> {this.props.selectedEvent ?

                        <div>
                            {this.props.selectedEvent.type.endsWith("_STREAMING") === false ? // add another panel to the "multi-panel-wrapper" children?
                                <EventMedia
                                    shouldShowAlternateCameraType={true}
                                    selectedRavenUuid={this.props.selectedRaven.ravenUuid}
                                    selectedEventId={this.props.selectedEvent.eventId}
                                    mqttService={this.props.mqttService}
                                    features={this.props.features}
                                    mediaRequestType={mediaRequestType}
                                    unplugged={this.props.selectedRaven.unplugged}
                                    offline={(this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline)}
                                    onLiveStream={this.onLiveStream}
                                />
                                :
                                null // streaming playback does not support two separate cameras (or it is a clustered component if multiple streaming events on the same timestamp)
                            }
                        </div>
                        :
                        <div>
                            <LiveMedia
                                roadCamera={liveMediaRoadCamera}
                                cabinCamera={liveMediaCabinCamera}
                                unplugged={this.props.selectedRaven.unplugged}
                                offline={(this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline)}
                                onLiveStream={this.onLiveStream}
                            />

                            {pathname.endsWith('/info') ?
                                <LiveMedia
                                    shouldShowAlternateCameraType={true}
                                    roadCamera={liveMediaRoadCamera}
                                    cabinCamera={liveMediaCabinCamera}
                                    unplugged={this.props.selectedRaven.unplugged}
                                    offline={(this.props.selectedRaven.vehicleState && this.props.selectedRaven.vehicleState.ravenOffline)}
                                    onLiveStream={this.onLiveStream}
                                />
                                :
                                null
                            }
                        </div>


                        /* end media_view */
                    } </> : null
                }
            </div>
        )
    }
}

ImageDetails.propTypes = {
    features: PropTypes.shape({
        debug: PropTypes.bool,
        media_request: PropTypes.bool,
    }).isRequired,
    stage: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    selectedEvent: PropTypes.shape({
        media: PropTypes.arrayOf(PropTypes.shape({
            signedUrl: PropTypes.string
        }))
    }),
    selectedRaven: PropTypes.shape({
        ravenUuid: PropTypes.string.isRequired,
        noServicePlan: PropTypes.bool,
        dashboard: PropTypes.shape({
            events: PropTypes.arrayOf(PropTypes.object)
        })
    }).isRequired,
    mqttService: PropTypes.object,
    unitOfMeasure: PropTypes.string.isRequired,
    showcaseTargetRavenUuid: PropTypes.string,
}